import axios from 'axios'
import * as Sentry from '@sentry/react'

const axiosInstance = axios.create({
	baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
	paramsSerializer: {
		serialize: (params) => {
			const searchParams = new URLSearchParams()
			Object.entries(params).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					searchParams.append(key, value.join(','))
				} else if (value !== undefined && value !== null) {
					searchParams.append(key, String(value))
				}
			})

			return searchParams.toString()
		},
	},
})

axiosInstance.interceptors.request.use((config) => {
	const token = localStorage.getItem('token')

	if (token) {
		config.headers.Authorization = `Bearer ${token}`
	}

	return config
})

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status >= 500) {
			Sentry.captureException(error)
		}

		if (
			error.response &&
			[401].includes(error.response.status) &&
			localStorage.getItem('token')
		) {
			localStorage.removeItem('token')

			const currentPath = window.location.pathname + window.location.search
			const encodedPath = encodeURIComponent(currentPath)
			location.href = `/login?sessionExpired=true&path=${encodedPath}`
		}

		return Promise.reject(error)
	},
)

export default axiosInstance
